import React, { useState } from 'react';
import { logoBase64 } from './logo';
import { Link, useNavigate } from 'react-router-dom'; 
import styles from './Header.module.css'; 
import pageContent from '../../data/pageContent'; 

function Header() {
  const [showSubLinks, setShowSubLinks] = useState(null);
  const navigate = useNavigate();

  const handleToggleSubLinks = (section) => {
    setShowSubLinks((prevState) => (prevState === section ? null : section)); // Toggle sub-links
  };

  // Only show main top-level links in the header
  // Filter out any keys that might be sublink slugs
  const mainSections = Object.keys(pageContent).filter(key => {
    if (key === "privacy") return false;
    if (key === "") return false;
    for (const sectionKey in pageContent) {
      if (pageContent[sectionKey].subLinks) {
        if (pageContent[sectionKey].subLinks.some(subLink => subLink.slug === key)) {
          // This is a sublink in another section, don't include as a main nav item
          return false;
        }
      }
    }
    return true;
  });

  const handleNavClick = (key) => {
    // First check if it has sublinks
    if (pageContent[key].subLinks && pageContent[key].subLinks.length > 0) {
      // Toggle sublinks dropdown
      handleToggleSubLinks(key);
    } else {
      // Navigate directly to the page if no sublinks
      navigate(`/${key}`);
    }
  };

  return (
    <nav className={styles.header}>
      <div className={styles.logoContainer}>
        <Link to="/" className={styles.logoLink}>
          <img src={logoBase64} alt="Propertunity Logo" className={styles.logo} />
          <span className={styles.companyName}>Propertunity</span>
        </Link>
      </div>

      <div className={styles.navLinks}>
        {/* Only render main sections in the nav bar */}
        {mainSections.map((key) => {
          const page = pageContent[key];
          return (
            <div className={styles.navItem} key={key}>
              {/* Main Link */}
              <button
                className={styles.navLink}
                onClick={() => handleNavClick(key)}
              >
                {page.title}
                {/* Only show the dropdown icon if there are sub-links */}
                {page.subLinks && page.subLinks.length > 0 && (
                  <span
                    className={`${styles.dropdownIcon} ${
                      showSubLinks === key ? styles.rotated : ''
                    }`}
                  />
                )}
              </button>

              {/* Display SubLinks if present and this section is active */}
              {showSubLinks === key && page.subLinks && page.subLinks.length > 0 && (
                <div className={styles.subLinks}>
                  {page.subLinks.map((subLink, idx) => {
                    const path = `/${subLink.slug}`;
                    console.log(`Rendering sublink: ${subLink.title} → ${path}`);
                    return (
                      <Link
                        key={idx}
                        to={path}
                        className={styles.navLink}
                        onClick={() => console.log(`Clicked sublink: ${path}`)}
                      >
                        {subLink.title}
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
        <div className={styles.navItem}>
          <Link to="https://portal.propertunitycapital.com/login" className={styles.navLink}>
            Login
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Header;